import axios from "axios";
import config from "@/config";

export const capitalize = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const isObject = (item) => {
  return (
    item && typeof item === "object" && !Array.isArray(item) && item != null
  );
};

export const generateID = (length = 6) => {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const moveArray = (arr, fromIndex, toIndex) => {
  var element = arr[fromIndex];
  arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, element);
};

export const rgb2hex = (rgb) => {
  rgb = rgb.match(
    /^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i
  );

  return rgb && rgb.length === 4
    ? "#" +
        ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
        ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
        ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2)
    : "";
};

// to extend defaults with user options
// credit: http://stackoverflow.com/questions/27936772/deep-object-merging-in-es6-es7#answer-34749873
export const extend = (target, source) => {
  if (typeof Object.assign !== "function") {
    (function() {
      Object.assign = function(target) {
        "use strict";
        // We must check against these specific cases.
        if (target === undefined || target === null) {
          throw new TypeError("Cannot convert undefined or null to object");
        }

        let output = Object(target);
        for (let index = 1; index < arguments.length; index++) {
          let source = arguments[index];
          if (source !== undefined && source !== null) {
            for (let nextKey in source) {
              if (source.hasOwnProperty(nextKey)) {
                output[nextKey] = source[nextKey];
              }
            }
          }
        }
        return output;
      };
    })();
  }

  let output = Object.assign({}, target);
  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach((key) => {
      if (isObject(source[key])) {
        if (!(key in target)) {
          Object.assign(output, {
            [key]: source[key],
          });
        } else {
          output[key] = extend(target[key], source[key]);
        }
      } else {
        Object.assign(output, {
          [key]: source[key],
        });
      }
    });
  }
  return output;
};

export const clone = (source, ignoreRefs = false) => {
  if (Object.prototype.toString.call(source) === "[object Array]") {
    let cloneResult = [];
    for (let i = 0; i < source.length; i++) {
      cloneResult[i] = clone(source[i]);
    }
    return cloneResult;
  } else if (Object.prototype.toString.call(source) === "[object Null]") {
    // fixes an issue where null values were converted to {}
    return null;
  } else if (Object.prototype.toString.call(source) === "[object Date]") {
    return source;
  } else if (typeof source === "object") {
    let cloneResult = {};
    for (let prop in source) {
      if (source.hasOwnProperty(prop)) {
        cloneResult[prop] = clone(source[prop]);
      }
    }
    return cloneResult;
  } else {
    if (!ignoreRefs) {
      return source;
    }
  }
};

export const extendArray = (arrToExtend, resultArr) => {
  let extendedArr = [];
  arrToExtend.map((item) => {
    extendedArr.push(extend(resultArr, item));
  });
  arrToExtend = extendedArr;
  return arrToExtend;
};

export const removeDifferences = (original, removeKeys) => {
  // Get keys of to be deleted properties.
  var keys = Object.keys(removeKeys);

  // Iterate all properties on removeKeys.
  for (let key of keys) {
    // Check if property exists on original.
    if (
      typeof original[key] !== "undefined" &&
      typeof removeKeys[key] !== "undefined"
    ) {
      if (JSON.stringify(original[key]) === JSON.stringify(removeKeys[key])) {
        delete removeKeys[key];
      }

      if (
        typeof original[key] !== "object" &&
        typeof removeKeys[key] !== "object" &&
        parseInt(original[key]) === parseInt(removeKeys[key])
      ) {
        delete removeKeys[key];
      }
      // If the property is an object, call same function to remove properties.
      if (typeof removeKeys[key] === "object") {
        removeDifferences(original[key], removeKeys[key]);
      } else {
        if (original[key] === removeKeys[key]) {
          delete removeKeys[key];
        }
      }
    }
  }
  return removeKeys;
};

export const refReplacerInStringify = () => {
  let m = new Map(),
    v = new Map(),
    init = null;

  return function(field, value) {
    let p = m.get(this) + (Array.isArray(this) ? `[${field}]` : "." + field);
    let isComplex = value === Object(value);

    if (isComplex) m.set(value, p);

    let pp = v.get(value) || "";
    let path = p.replace(/undefined\.\.?/, "");
    let val = pp ? `#REF:${pp[0] == "[" ? "$" : "$."}${pp}` : value;

    !init ? (init = value) : val === init ? (val = "#REF:$") : 0;
    if (!pp && isComplex) v.set(value, path);

    return val;
  };
};

export const setAxiosBaseURL = (baseurl) => {
  axios.defaults.baseURL = baseurl;
};

export const setAuthHeader = (auth) => {
  axios.defaults.headers.common["Authorization"] = auth;
};

export const setAxiosHeaderContentType = (contentType) => {
  axios.defaults.headers.common["Content-Type"] = contentType;
};

export const getCookieValue = (a) => {
  var b = document.cookie.match("(^|;)\\s*" + a + "\\s*=\\s*([^;]+)");
  return b ? b.pop() : "";
};

export const isEmpty = (obj) => {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      return false;
    }
  }
  return true;
};

export const createFormData = (obj) => {
  var formData = new FormData();

  for (const key of Object.keys(obj)) {
    formData.append(key, obj[key]);
  }

  return formData;
};

export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
    navigator.userAgent
  );
};

export const scriptLoader = (src, onScriptLoad = function() {}) => {
  var script = document.createElement("script");
  script.onload = onScriptLoad();
  script.src = src;
  document.head.appendChild(script);
};

export const uuidv4 = () => {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
};

export const removeDataAttrs = (el) => {
  var dataset = el.dataset;
  for (var key in dataset) {
    el.removeAttribute(
      "data-" +
        key
          .split(/(?=[A-Z])/)
          .join("-")
          .toLowerCase()
    );
  }
};

export const getDate = (timestamp, utc) => {
  return utc
    ? new Date(new Date(timestamp).toUTCString())
    : new Date(timestamp);
};

export const decomposeUrlParams = (query) => {
  if (!query) {
    return {};
  }
  return (/^[?#]/.test(query) ? query.slice(1) : query)
    .split("&")
    .reduce((params, param) => {
      let [key, value] = param.split("=");
      params[key] = value ? decodeURIComponent(value.replace(/\+/g, " ")) : "";
      return params;
    }, {});
};

export const setAxiosDefaultHeaders = () => {
  const credentials = window.localStorage.getItem("_verificationToken");
  if (credentials !== null && typeof credentials !== "undefined") {
    setAuthHeader("Bearer " + credentials);
  } else {
    localStorage.clear();
  }

  setAxiosBaseURL(config.BASE_API_URL);
  setAxiosHeaderContentType("application/json");
};

export const compareValues = (key, order = "asc") => {
  return function(a, b) {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      return 0;
    }

    const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
    const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

    let comparison = 0;
    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return order === "desc" ? comparison * -1 : comparison;
  };
};

// Firefox 1.0+
export const isFirefox = typeof InstallTrigger !== "undefined";
// Chrome 1 - 71

export const isChrome =
  !!window.chrome && navigator.userAgent.indexOf("Chrome") !== -1;
export const isIE = false || !!document.documentMode;
export const isEdge = !isIE && !!window.StyleMedia;

export const getGoogleFontList = () => {
  // how was this generated?
  // the font-picker html was copied from the console
  return `<ul class="expanded"><li><button type="button" class="font-abel ">Abel<-abril-fatface ">Abril Fatface<-acme ">Acme<-amatic-sc ">Amatic SC<-antic-slab ">Antic Slab<-anton ">Anton<-architects-daughter ">Architects Daughter<-archivo-narrow ">Archivo Narrow<-arimo ">Arimo<-arvo ">Arvo<-asap ">Asap<-assistant ">Assistant<-balsamiq-sans ">Balsamiq Sans<-barlow ">Barlow<-barlow-condensed ">Barlow Condensed<-bebas-neue ">Bebas Neue<-bitter ">Bitter<-bree-serif ">Bree Serif<-cabin ">Cabin<-cairo ">Cairo<-catamaran ">Catamaran<-caveat ">Caveat<-comfortaa ">Comfortaa<-cormorant-garamond ">Cormorant Garamond<-crimson-text ">Crimson Text<-dancing-script ">Dancing Script<-dm-sans ">DM Sans<-domine ">Domine<-dosis ">Dosis<-eb-garamond ">EB Garamond<-exo-2 ">Exo 2<-fira-sans ">Fira Sans<-fira-sans-condensed ">Fira Sans Condensed<-fjalla-one ">Fjalla One<-heebo ">Heebo<-hind ">Hind<-hind-madurai ">Hind Madurai<-hind-siliguri ">Hind Siliguri<-ibm-plex-sans ">IBM Plex Sans<-ibm-plex-serif ">IBM Plex Serif<-inconsolata ">Inconsolata<-indie-flower ">Indie Flower<-inter ">Inter<-josefin-sans ">Josefin Sans<-kanit ">Kanit<-karla ">Karla<-lato ">Lato<-libre-baskerville ">Libre Baskerville<-libre-franklin ">Libre Franklin<-lobster ">Lobster<-lora ">Lora<-martel ">Martel<-maven-pro ">Maven Pro<-merriweather ">Merriweather<-merriweather-sans ">Merriweather Sans<-montserrat ">Montserrat<-mukta ">Mukta<-nanum-gothic ">Nanum Gothic<-noto-sans ">Noto Sans<-noto-sans-jp ">Noto Sans JP<-noto-sans-kr ">Noto Sans KR<-noto-sans-sc ">Noto Sans SC<-noto-sans-tc ">Noto Sans TC<-noto-serif ">Noto Serif<-nunito ">Nunito<-nunito-sans ">Nunito Sans<-open-sans ">Open Sans<-oswald ">Oswald<-overpass ">Overpass<-oxygen ">Oxygen<-pacifico ">Pacifico<-permanent-marker ">Permanent Marker<-play ">Play<-playfair-display ">Playfair Display<-poppins ">Poppins<-prompt ">Prompt<-pt-sans ">PT Sans<-pt-sans-narrow ">PT Sans Narrow<-pt-serif ">PT Serif<-questrial ">Questrial<-quicksand ">Quicksand<-raleway ">Raleway<-roboto ">Roboto<-roboto-condensed ">Roboto Condensed<-roboto-mono ">Roboto Mono<-roboto-slab ">Roboto Slab<-rubik ">Rubik<-shadows-into-light ">Shadows Into Light<-signika ">Signika<-slabo-27px ">Slabo 27px<-source-code-pro ">Source Code Pro<-source-sans-pro ">Source Sans Pro<-source-serif-pro ">Source Serif Pro<-teko ">Teko<-titillium-web ">Titillium Web<-ubuntu ">Ubuntu<-varela-round ">Varela Round<-work-sans ">Work Sans<-yanone-kaffeesatz ">Yanone Kaffeesatz<-zilla-slab ">Zilla Slab</button></li></ul>`;
};

export const getBlankCanvasProps = () => {
  return {
    width: 600,
    height: 500,
    background: "#fff",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundOverlayColor: "",
  };
};

export const parseJwt = (token) => {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function(c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
};
